import { useEffect } from "react";
import { CarrierDashboard } from "@/components/CarrierDashboard";
import { useOrganization } from "@/hooks/useOrganization";

const CarrierDashboardPage = () => {
  const { currentOrganization, loading } = useOrganization();

  useEffect(() => {
    document.title = "Carrier Dashboard | Shohnat";
    const metaDesc = document.querySelector('meta[name="description"]') || (() => {
      const m = document.createElement('meta');
      m.setAttribute('name', 'description');
      document.head.appendChild(m);
      return m;
    })();
    metaDesc.setAttribute('content', 'Carrier dashboard to view available loads, assignments, and operations.');
  }, []);

  if (loading || !currentOrganization) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary" aria-label="Loading carrier dashboard"></div>
      </div>
    );
  }

  const companyName = currentOrganization.organization_name || 'My Company';

  return (
    <main>
      <CarrierDashboard companyName={companyName} />
    </main>
  );
};

export default CarrierDashboardPage;
